import { Card } from '@/components/ui/card';
import React from 'react'
import { useLocation, useParams } from 'react-router-dom';

export default function ManagementDetail() {
    const { managementId } = useParams();
    const location = useLocation();
    const { item } = location.state || {};
    console.log(item);
    const baseUrl = process.env.REACT_APP_BASE_URL;
    return (
        <>
            <div className="container my-6">
                <Card className="border border-gray-200 shadow-sm p-3">
                    <h2 className="text-2xl font-semibold mb-4">Complaint from:</h2>
                    <div className="ms-10 ">
                        <div>
                            <p>
                                <strong>Name:</strong> {item?.filedBy?.name || "N/A"}
                            </p>
                            <p>
                                <strong>Phone:</strong> {item?.filedBy?.contactNumber || "N/A"}
                            </p>
                            <p>
                                <strong>Email:</strong> {item?.filedBy?.email || "N/A"}
                            </p>

                            <p>
                                <strong>Flat No:</strong> {item?.filedBy?.flatNo || "N/A"}
                            </p>
                        </div>
                        {/* <div>
                            <p>
                                <strong>Lease Start Date:</strong> {tenant?.leaseStartDate || "N/A"}
                            </p>
                            <p>
                                <strong>Lease End Date:</strong> {tenant?.leaseEndDate || "N/A"}
                            </p>
                            <p>
                                {tenant?.isActive && <strong>Active:</strong>} {tenant?.isActive === true ? "True" : "False"}
                            </p>
                            <p>
                                {tenant?.status && <strong>Status:</strong>} {tenant?.status || "N/A"}
                            </p>
                            <p>
                                {tenant?.status && <strong>Building:</strong>} 
                            </p>
                        </div> */}
                    </div>
                </Card>
            </div>
            <Card className="p-5 my-6 w-full">
                <h2 className="text-2xl font-semibold mb-4">Details</h2>
                <div className="flex flex-wrap justify-between gap-4">
                    <div>
                        <p>
                            <strong>Title:</strong> {item?.title || "N/A"}
                        </p>
                        <p>
                            <strong>Description:</strong> {item?.description || "N/A"}
                        </p>
                    </div>
                    <div>
                        <p>
                            <strong>Status:</strong> {item?.status || "N/A"}
                        </p>
                        <p>
                            <strong>Created At:</strong> {item?.createdAt || "N/A"}
                        </p>
                    </div>
                    <div>
                        {item?.photos?.length > 0 && (
                            <div className="mt-3 flex gap-3 items-center">
                                <div className="flex gap-4 mt-2">
                                    {item?.photos.map((photo: any, index: number) => (
                                        <img
                                            key={index}
                                            src={baseUrl + "/" + photo}
                                            alt={`Complaint Photo ${index + 1}`}
                                            className="h-14 w-28 object-cover rounded-md"
                                        />
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>

            </Card>
        </>
    )
}
